/**
 * Container for ArtistEvents
 *
 * @module components/ArtistEvents/ArtistEvents
 */
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import ArtistEventsItem from '../../components/ArtistEvents/ArtistEventsItem/ArtistEventsItem';
import { ArtistEventsConstants, messages as m } from '../../constants/ArtistEvents';
import { getInDomain } from '../../domains/externalUtils';
import { isCurrentDominantColorDark } from '../../lib/UIStateUtils';
import { createBEM } from '../../lib/utils/css';

import './ArtistEvents.scss';

export class ArtistEvents extends React.Component {
  static propTypes = {
    artistPandoraId: PropTypes.string,
    isNowPlaying: PropTypes.bool,
    isRowItemArtistEvents: PropTypes.bool,
    someArtistEvents: ImmutablePropTypes.listOf(PropTypes.string),
    useDarkTheme: PropTypes.bool,
    useLightTheme: PropTypes.bool,
    isOnDemandNowPlaying: PropTypes.bool,
    maxEvents: PropTypes.number,
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.artistPandoraId !== nextProps.artistPandoraId ||
      this.props.isNowPlaying !== nextProps.isNowPlaying ||
      this.props.isRowItemArtistEvents !== nextProps.isRowItemArtistEvents ||
      this.props.useDarkTheme !== nextProps.useDarkTheme ||
      this.props.useLightTheme !== nextProps.useLightTheme ||
      !this.props.someArtistEvents.equals(nextProps.someArtistEvents)
    );
  }

  renderArtistEventsItems = () => {
    return (
      this.props.someArtistEvents &&
      this.props.someArtistEvents.map((id, index) => {
        return (
          <ArtistEventsItem
            eventId={id}
            artistPandoraId={this.props.artistPandoraId}
            isNowPlaying={this.props.isNowPlaying}
            isRowItemArtistEvents={this.props.isRowItemArtistEvents}
            useDarkTheme={this.props.useDarkTheme}
            useLightTheme={this.props.useLightTheme}
            isOnDemandNowPlaying={this.props.isOnDemandNowPlaying}
            noBorder={this.props.isNowPlaying && !this.props.isOnDemandNowPlaying}
            key={`${index}-${id}`}
          />
        );
      })
    );
  };

  renderArtistEventsTitle = () => {
    const titleClass = createBEM('ArtistEvents__title', {
      lightTheme: this.props.useLightTheme,
    });

    return (
      <header className={titleClass}>
        <FormattedMessage {...m.onTour} />
      </header>
    );
  };

  render() {
    const mainClass = createBEM('ArtistEvents', {
      nowPlaying: this.props.isNowPlaying,
      onDemandNowPlaying: this.props.isOnDemandNowPlaying,
      lightTheme: this.props.useLightTheme,
    });

    if (this.props.isRowItemArtistEvents) {
      return <div className={mainClass}>{this.renderArtistEventsItems()}</div>;
    }

    return (
      <div className={mainClass}>
        {this.renderArtistEventsTitle()}
        {this.renderArtistEventsItems()}
      </div>
    );
  }
}

function getMaxNumEvents(props) {
  return props.maxEvents || ArtistEventsConstants.MAX_NUM_EVENTS_DEFAULT;
}

function getSomeArtistEvents(state, ownProps) {
  let events = List();
  if (ownProps.artistPandoraId) {
    events = getInDomain('catalog.utils.getArtistEventsFromState', List())(
      state,
      ownProps.artistPandoraId,
    ).map(event => {
      return event.get('id');
    });
  }

  if (!events.isEmpty()) {
    const maxSize = getMaxNumEvents(ownProps);
    events = events.setSize(Math.min(maxSize, events.size));
  }
  return events;
}

export function mapStateToProps(state, ownProps) {
  const props = {
    someArtistEvents: getSomeArtistEvents(state, ownProps),
  };

  if (ownProps.isNowPlaying) {
    props.useDarkTheme = isCurrentDominantColorDark(state);
    props.useLightTheme = !isCurrentDominantColorDark(state);
  }
  return props;
}

export default connect(mapStateToProps)(ArtistEvents);
